export const addMembersToOrganizationBulkActionEvent = 'add-members';
export const changeMembersRoleBulkActionEvent = 'change-members-role';
export const changeMembersRoleAndStatusBulkActionEvent = 'change-members-role-and-status';
export const removeMembersFromOrganizationBulkActionEvent = 'remove-members';
export const changeMembersInOrganizationActionEvent = 'change-members';
